import type { RootState } from '../../createStore'

export const selectCrsUser = (state: RootState) => state.metadata.user.crs
export const selectCrsUserId = (state: RootState) => state.metadata.user.crs?.member.user.id
export const selectCrsToken = (state: RootState) => state.metadata.auth.token.crs
const selectCrsFirstName = (state: RootState) => selectCrsUser(state)?.member?.user['first_name']
const selectCrsLastName = (state: RootState) => selectCrsUser(state)?.member?.user['last_name']
export const selectCrsEmail = (state: RootState) => selectCrsUser(state)?.member?.user['email']
export const selectCrsFullName = (state: RootState) => `${selectCrsFirstName(state)} ${selectCrsLastName(state)}`
export const selectCrsUserInitials = (state: RootState) =>
  `${selectCrsFirstName(state)?.slice(0, 1)}${selectCrsLastName(state)?.slice(0, 1)}`

export const selectRememberMeEmail = (state: RootState) => state.metadata.rememberMeEmail
export const selectTargetGroup = (state: RootState) => state.metadata.targetGroup
export const selectDomain = (state: RootState) => state.metadata.domain
